function Radios() {
    let radios = document.querySelectorAll('.form-radio');
    if (typeof radios != "undefined" && radios != null) {
      Array.prototype.forEach.call(document.querySelectorAll('.form-radio'), function(radio){
        radio.addEventListener('click', () => {
          radio.parentElement.classList.add('active');
          Array.prototype.forEach.call(document.querySelectorAll('.form-radio'), function(otherRadio){
            otherRadio.checked ? null : otherRadio.parentElement.classList.remove('active');
          })
        })
      });
    }
  }
  
  export default Radios;


// WEBPACK FOOTER //
// ./src/js/app/components/Radios.js